//components
import ContentItemAudienceCount from "@/components/elements/lists/ContentItemAudienceCount";
import ContentItemPublishedStatus from "@/components/elements/lists/ContentItemPublishedStatus";
import ListContentTile from "@/components/elements/lists/ListContentTitle";
import SourceListActions from "./SourceListActions";
import AddedByDefaultActions from "./AddedByDefault";

//interfaces
import { feedSourceStatus, ISourceListItem } from "@/interfaces/CombinedFeed";

//helpers
import { scheduledStatus } from "@/helpers/List";




export function SourceListContentRow(appGuid: string, content: ISourceListItem, onOpenListClick: (listId: number, listTitle: string)=>void, addToSourceListClick: (listId: number)=>void, onRemoveSourceListClick: (listId: number)=> void, isAlteringContentItem:boolean, isRefreshingFeed: boolean) {
    if (content.type === "list") {      

        return {
            content: [
                <ListContentTile 
                    key={`${content.id}-content-title`}
                    listId={content?.parentIdAndTitles[0]?.id.toString()}
                    appGuid={appGuid}
                    item={content}
                    status={<ContentItemPublishedStatus item={content}/>}
                    archiveStatus={scheduledStatus(content.scheduledPublishDate, content.scheduledArchiveDate)}
                    isNotALink
                />,

                <ContentItemAudienceCount
                    key={`${content.id}-audience-coint`}
                    count={content.groupUserCount}
                    everyoneHasAccess={content.everyoneHasAccess}
                />,

                content.feedSourceListStatus !== feedSourceStatus.default
                    ?   <SourceListActions 
                            content={content} 
                            isAlteringContentItem={isAlteringContentItem} 
                            isRefreshingFeed={isRefreshingFeed} 
                            onOpenListClick={() => onOpenListClick(content.id, content.title)} 
                            addToSourceListClick={() => addToSourceListClick(content.id)} 
                            onRemoveSourceListClick={() => onRemoveSourceListClick(content.id)}                    
                        />

                    :   <AddedByDefaultActions
                            content={content} 
                            isAlteringContentItem={isAlteringContentItem} 
                            isRefreshingFeed={isRefreshingFeed} 
                            onOpenListClick={() => onOpenListClick(content.id, content.title)}
                        />                    
            ],
        }
    }
}
